// extracted by mini-css-extract-plugin
export var infoRow = "_pp-2";
export var labelContainer = "_pp-0";
export var rightInfo = "_pp-1";